import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { InfoIconCoachLight } from "@images/svgIcons/infoIcon"
import { useCoachCategories } from "@modules/coachCategories/hooks/useCoachCategories"
import { word } from "@modules/core/utils/i18n"
import { cn } from "@modules/lib/utils"
import { HUMultiSelect } from "@modules/ui/huMultiSelect"
import { Suspense } from "react"

type CoachOfferCategoriesInputProps = {
  selectedIds: string[]
  onChangeCategories: (ids: string[]) => void
  className?: string
}

export function CoachOfferCategoriesInput(props: CoachOfferCategoriesInputProps) {
  return (
    <Suspense>
      <CoachOfferCategoriesInputInner {...props} />
    </Suspense>
  )
}

function CoachOfferCategoriesInputInner({
  selectedIds,
  onChangeCategories,
  className,
}: CoachOfferCategoriesInputProps) {
  const { data: categories } = useCoachCategories()

  function onToggleAllCategories() {
    if (selectedIds.length === categories.length) {
      onChangeCategories([])
    } else {
      onChangeCategories(categories.map((c) => c.id))
    }
  }

  const isEmpty = categories.length === 0

  return (
    <div
      className={cn(
        "flex flex-col gap-5 rounded-2xl border-2 border-solid border-surface-border-gray-default bg-surface-background-secondary px-5 py-4",
        className,
      )}
    >
      <div className="flex w-full flex-row items-start justify-between gap-5">
        <Text fontStyle="TS">{word("coach.offers.form.infos.categories.planningCategories.title")}</Text>
        <div className="flex flex-col items-end">
          <Text fontStyle="BS" className={isEmpty ? "text-textOnSurface-disabled" : "text-textOnSurface-subtle"}>
            {`${selectedIds.length.toString()}/${categories.length.toString()} ${word("global.selectedFeminine", {
              count: selectedIds.length,
            })}`}
          </Text>
          <Button
            variant="underline"
            size="xs"
            type="button"
            onClick={onToggleAllCategories}
            disabled={isEmpty}
            className="pr-0"
          >
            <Text fontStyle="LS">
              {selectedIds.length !== categories.length
                ? word("global.filters.selectAll")
                : word("global.filters.unselectAll")}
            </Text>
          </Button>
        </div>
      </div>

      {isEmpty ? (
        <div className="flex items-center gap-3">
          <InfoIconCoachLight className="shrink-0" color="currentColor" />
          <Text fontStyle="BS" className="text-textOnSurface-default">
            {word("coach.offers.form.infos.categories.emptyState")}
          </Text>
        </div>
      ) : (
        <HUMultiSelect
          options={categories.map((category) => ({
            label: category.name,
            value: category.id,
          }))}
          values={selectedIds}
          viewMore={word("box.offer.form.infos.myActivities.showMore")}
          onChange={(value) => {
            onChangeCategories(value)
          }}
        />
      )}
    </div>
  )
}
